import { Button, Dialog, DialogActions, DialogContent } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { Broker_OrderType, OrderType, Product, TransactionType } from '../../proto/generated/order'
import { useCallback, useMemo } from 'react'
import { selectQuickOrderData } from '../../selectors/orders'
import { setQuickOrderData } from '../../reducer/orders.reducer'
import { getSecuritySymbol } from '../../util/security'
import { WarningAmber } from '@mui/icons-material'
import { selectBrokers, selectPrimaryTradingAccount } from '../../selectors/user'
import DraggableDialogTitle from '../common/DraggableDialogTitle'
import { BrokerId } from '../../util/tradingAccounts'

const SecurityNotTradableDialog = () => {
    const dispatch = useDispatch()
    const tradeData = useSelector(selectQuickOrderData)
    const {
        openDialog,
        order
    } = tradeData
    const securityKey = (order?.security?.exchange && order?.security?.code) ? getSecuritySymbol(order?.security?.exchange ?? 0, order?.security?.code ?? '') : ''
    const primaryTradingAccount = useSelector(selectPrimaryTradingAccount)
    const brokers = useSelector(selectBrokers)
    const currentBrokerName = useMemo(() => {
        return brokers.find(b => b.code === (primaryTradingAccount?.brokerCode ?? BrokerId.BROKER_UNKNOWN))?.name ?? 'Tick2trade'
    }, [brokers, primaryTradingAccount])

    const onClose = useCallback(() => {
        dispatch(setQuickOrderData({
            openDialog: false,
            mode: 'regular',
            type: 'trade',
            isSquareOffOrder: false,
            order: {
                transactionType: TransactionType.TRANSACTION_TYPE_UNKNOWN,
                security: undefined,
                editOrder: undefined,
                brokerOrderType: Broker_OrderType.LIMIT_ORDER,
                orderType: OrderType.NORMAL,
                product: Product.CNC,
                price: undefined,
                quantity: 0,
                maxQuantity: 0,
            }
        }))
    }, [dispatch])

    return (
        <Dialog open={openDialog} onClose={onClose} PaperProps={{ sx: { maxWidth: '400px' } }}>
            <DraggableDialogTitle><WarningAmber fontSize="large" /> Non-tradable symbol</DraggableDialogTitle>
            <DialogContent sx={{ pb: '5px' }}>
                Symbol {securityKey} cannot be traded
                on {primaryTradingAccount?.brokerCode === BrokerId.PAPER_TRADING ? 'Tick2trade\'s Practice Mode' : currentBrokerName}
            </DialogContent>
            <DialogActions>
                <Button variant="contained" onClick={onClose}>Ok</Button>
            </DialogActions>
        </Dialog>
    )
}

export default SecurityNotTradableDialog